const TYPE_BLOG = "ContentfulBlog";
const TYPE_EVENT = "ContentfulEvent";
const TYPE_MICRO_ASSET = "ContentfulMicroAsset";
const TYPE_PAGE_FLEXIBLE = "ContentfulPageFlexible";
const TYPE_MARKETO_FORM = "ContentfulMarketoForm";
const TYPE_CTA = "ContentfulCta";
const TYPE_RESOURCE = "ContentfulResource";
const TYPE_CARD = "ContentfulCard";
const TYPE_NEWS = "ContentfulNews";

const contentTypeContentfulTypeMap = {
    microAsset: TYPE_MICRO_ASSET,
    pageFlexible: TYPE_PAGE_FLEXIBLE,
    blog: TYPE_BLOG,
    news: TYPE_NEWS,
    resource: TYPE_RESOURCE,
    marketoForm: TYPE_MARKETO_FORM,
};

/**
 * Exported constants.
 */
export {
    TYPE_BLOG,
    TYPE_EVENT,
    TYPE_MICRO_ASSET,
    TYPE_PAGE_FLEXIBLE,
    TYPE_MARKETO_FORM,
    TYPE_CTA,
    TYPE_RESOURCE,
    TYPE_CARD,
    TYPE_NEWS,
    contentTypeContentfulTypeMap,
};
